import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { HbaseLinkedService, hbaseAuthTypes } from 'app/model/linkedservice/hbase.linkedservice';
import { HbaseCopySource } from 'app/model/pipeline/copysource/hbase.copysource';
import { enableSslWithTAARadioSwitch } from './linked-service-shared-fields';
import { format, stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const hBaseMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(HbaseLinkedService).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.HBase_DisplayText),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-hbase'
    },
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    isFirstClass: true,
    supportDatasetV2: true,
    notShowInTypeSelection: true,
    category: ['Database'],
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(HbaseCopySource).name],
    controls: [
        {
            type: 'textbox',
            bind: 'host',
            label: stringResources.ModelName_Host,
            required: true,
            placeholder: stringResources.Host_Placeholder,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            warningMessageCalculator: (value: string) =>
                stringIsNullOrEmpty(value) ? '' : stringResources.infoSentViaUrlWarning,
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'port',
            label: stringResources.ModelName_Port,
            isLabelVertical: true,
            inputType: 'number',
            defaultValue: 443,
            min: 0
        },
        {
            type: 'textbox',
            bind: 'httpPath',
            label: stringResources.ModelName_HttpPath,
            placeholder: stringResources.Hbase_LinkedService_HttpPath_Placeholder,
            isLabelVertical: true
        },
        {
            type: 'select-switch',
            bind: 'authenticationType',
            label: stringResources.ModelName_AuthenticationType,
            options: [
                {
                    label: stringResources.Anonymous_DisplayText,
                    value: hbaseAuthTypes.Anonymous
                },
                {
                    label: stringResources.Basic_DisplayText,
                    value: hbaseAuthTypes.Basic
                }
            ],
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true,
            defaultValue: hbaseAuthTypes.Anonymous,
            cases: [
                {
                    caseValue: hbaseAuthTypes.Basic,
                    children: [
                        {
                            type: 'textbox',
                            bind: 'username',
                            label: stringResources.ModelName_UserName,
                            required: true,
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            isLabelVertical: true
                        },
                        {
                            type: 'dynamic-akv-switcher',
                            bind: 'password',
                            label: stringResources.ModelName_Password,
                            child: {
                                type: 'password',
                                label: stringResources.ModelName_Password,
                                required: true,
                                isLabelVertical: true
                            },
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                                format(stringResources.ModelName_DisplayTextPreviewTemplate, stringResources.HBase_DisplayText),
                                stringResources.ModelName_Password)
                        }
                    ]
                }
            ]
        },
        enableSslWithTAARadioSwitch
    ]
};
